import {
  collection,
  onSnapshot
} from 'firebase/firestore'
import { FIRESTORE_COLLECTIONS } from './data/firebaseModel'
import { firestore } from './firebase/firebaseClient'
import { showSystemNotification } from './pwaService'

const NOTIFICATION_SOURCES = [
  {
    key: 'courseApplication',
    collectionName: FIRESTORE_COLLECTIONS.coursesOrders,
    title: 'Новая заявка на курс',
    message: item => contactLine(item) || 'Поступила новая заявка на курс.',
    route: '/applications',
    adminOnly: false
  },
  {
    key: 'eventApplication',
    collectionName: FIRESTORE_COLLECTIONS.eventsOrders,
    title: 'Новая заявка на мероприятие',
    message: item => contactLine(item) || 'Поступила новая заявка на мероприятие.',
    route: '/applications',
    adminOnly: false
  },
  {
    key: 'feedBack',
    collectionName: FIRESTORE_COLLECTIONS.feedBack,
    title: 'Новое сообщение FeedBack',
    message: item => contactLine(item) || messageLine(item) || 'Поступило новое сообщение обратной связи.',
    route: '/feedback',
    adminOnly: false
  },
  {
    key: 'callBack',
    collectionName: FIRESTORE_COLLECTIONS.callBack,
    title: 'Новая заявка CallBack',
    message: item => contactLine(item) || 'Поступила новая заявка на обратный звонок.',
    route: '/feedback',
    adminOnly: false
  },
  {
    key: 'user',
    collectionName: FIRESTORE_COLLECTIONS.users,
    title: 'Новый пользователь',
    message: item => item.email || item.name || 'В системе зарегистрировался новый пользователь.',
    route: '/users',
    adminOnly: true
  }
]

function normalizedValue(value) {
  if (value === undefined || value === null || value === '') return ''
  if (value && typeof value.toDate === 'function') return value.toDate().toISOString()
  if (typeof value === 'object') return ''
  return String(value)
}

function firstFilledValue(item, fields) {
  const meta = item.meta && typeof item.meta === 'object' ? item.meta : {}
  const key = fields.find(fieldKey => normalizedValue(meta[fieldKey]) || normalizedValue(item[fieldKey]))
  return key ? normalizedValue(meta[key] || item[key]) : ''
}

function contactLine(item) {
  return firstFilledValue(item, ['name', 'fullName', 'userName']) ||
    firstFilledValue(item, ['email', 'mail']) ||
    firstFilledValue(item, ['phone', 'tel', 'telephone'])
}

function messageLine(item) {
  return firstFilledValue(item, ['message', 'comment', 'text', 'question'])
}

function appUrl(route) {
  const base = window.location.origin + process.env.BASE_URL
  return `${base}#${route}`
}

function startCollectionListener(source, onCreated, onError) {
  let isInitialSnapshot = true
  const knownIds = new Set()

  return onSnapshot(collection(firestore, source.collectionName), snapshot => {
    if (isInitialSnapshot) {
      snapshot.docs.forEach(item => knownIds.add(item.id))
      isInitialSnapshot = false
      return
    }

    snapshot.docChanges().forEach(change => {
      if (change.type !== 'added' || knownIds.has(change.doc.id)) return
      knownIds.add(change.doc.id)
      Promise.resolve(onCreated(source, {
        id: change.doc.id,
        ...change.doc.data()
      })).catch(onError)
    })
  }, onError)
}

export function startAdminNotificationListeners({ store }) {
  const unsubscribers = []
  const enabledSources = NOTIFICATION_SOURCES.filter(source => {
    return !source.adminOnly || store.getters.isAdmin
  })

  const handleCreated = async (source, item) => {
    const message = source.message(item)
    const payload = {
      type: 'info',
      title: source.title,
      message,
      duration: 7000
    }

    await store.dispatch('notify', payload)
    await showSystemNotification({
      title: source.title,
      body: message,
      url: appUrl(source.route),
      tag: `${source.key}-${item.id}`
    }).catch(() => false)

    window.dispatchEvent(new CustomEvent('admin:remote-created', {
      detail: {
        source: source.key,
        collectionName: source.collectionName,
        itemId: item.id
      }
    }))

    if (['courseApplication', 'eventApplication'].includes(source.key)) {
      store.dispatch('fetchDb').catch(() => {})
    }
  }

  const handleError = error => {
    store.dispatch('notify', {
      type: 'warning',
      title: 'Уведомления временно недоступны',
      message: error.message || 'Не удалось подключить realtime-уведомления.'
    })
  }

  enabledSources.forEach(source => {
    unsubscribers.push(startCollectionListener(source, handleCreated, handleError))
  })

  return () => {
    unsubscribers.forEach(unsubscribe => unsubscribe())
  }
}
